import { Stack } from '@mui/material';

import RadioGroup from '../../../../components/FormControls/RadioGroup';
import CourseWidgetSkeleton from '../../../course/CourseWidget/Skeleton';
import { courseListClasses, RadioOption } from './styles';

export interface CourseListSkeletonProps {
  className?: string;
}

const CourseListSkeleton = ({ className }: CourseListSkeletonProps) => {
  return (
    <RadioGroup fullWidth className={className}>
      <Stack gap={1.5} px={2} py={0.5} my={-0.5} maxWidth="100%">
        {new Array(3).fill('').map((_, index) => (
          <RadioOption key={index} value={`${index}`}>
            <CourseWidgetSkeleton className={courseListClasses.courseCard} />
          </RadioOption>
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default CourseListSkeleton;
